import { Box } from "@mui/material";

export function ChartView() {
  return <Box>Chart View</Box>;
}
